'use es6';

import { useMemo } from 'react';
import { getParsedPathParams } from '../params';
export const useParsedPathParams = (params = {}) => useMemo(() => {
  return getParsedPathParams(params);
}, [params]);